<template>
	<div class="infor fl">
		<div class="infor-t clearfix">
			<div class="fl infor-t-l">账号设置</div>
		</div>
		<div v-if="!issuccess" class="">
            <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-top:50px;margin-left:40px;">
                <el-tab-pane label="更改密码" name="first">
                    <div class="login">
                        <div class="login-form">
                            <div>
                                <label class="login-form-lable">手机号</label>
                                <input readonly class="login-form_item" name="tel" placeholder="请输入手机号码" type="number" v-model="tel" />
                            </div>
                            <div class="pos-input">
                                <div class="">
                                    <span class="login-form-lable">短信验证</span>
                                    <input class="login-form_item" name="code" type="number" placeholder="请输入短信验证码"
                                           v-model="code" />
                                </div>
                                <div v-show="show" @click="getCode" class="code-block">发送验证码</div>
                                <div v-show="!show" class="code-block">{{count}} s</div>
                            </div>
                            <div v-if="wCode" class="font-wraing">
                                <img class="wraing-icon" src="../assets/3.png" /><span>{{wCode}}</span>
                            </div>
                            <div>
                                <label class="login-form-lable">密码</label>
                                <input class="login-form_item" name="paw" placeholder="请输入9~16位密码" type="password" v-model="paw" />
                            </div>
                            <div v-if="wPaw" class="font-wraing">
                                <img class="wraing-icon" src="../assets/3.png" /><span>{{wPaw}}</span>
                            </div>
                            <div>
                                <label class="login-form-lable">确认密码</label>
                                <input class="login-form_item" name="newPaw" placeholder="请输入确认密码" type="password"
                                       v-model="newPaw" />
                            </div>
                            <div v-if="wNewPaw" class="font-wraing">
                                <img class="wraing-icon" src="../assets/3.png" /><span>{{wNewPaw}}</span>
                            </div>
                            <button class="login-but" @click="login">确认修改</button>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="变更手机号" name="second">
                    <div class="login">
                        <div class="login-form">
                            <div>
                                <label class="login-form-lable">手机号</label>
                                <input readonly class="login-form_item" name="tel" placeholder="请输入手机号码" type="number" v-model="newPhoneData.tel" />
                            </div>
                            <div class="pos-input">
                                <div class="">
                                    <span class="login-form-lable">短信验证</span>
                                    <input class="login-form_item" type="number" placeholder="请输入短信验证码"
                                           v-model="newPhoneData.code" />
                                </div>
                                <div v-show="newPhoneData.show" @click="getCode2" class="code-block">发送验证码</div>
                                <div v-show="!newPhoneData.show" class="code-block">{{newPhoneData.count}} s</div>
                            </div>
                            <div v-if="newPhoneData.wCode" class="font-wraing">
                                <img class="wraing-icon" src="../assets/3.png" /><span>{{newPhoneData.wCode}}</span>
                            </div>
                            <div>
                                <label class="login-form-lable">新手机号</label>
                                <input class="login-form_item" placeholder="请输入新手机号" type="number" v-model="newPhoneData.newtel" />
                            </div>
                            <div v-if="newPhoneData.wPaw" class="font-wraing">
                                <img class="wraing-icon" src="../assets/3.png" /><span>{{newPhoneData.wPaw}}</span>
                            </div>
                            <button class="login-but" @click="changePhone">确认修改</button>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
		</div>
        <div v-else class="shenhjrkr">
            <img src="../assets/failesucee.png" alt />
            <p style="font-size: 20px;color:#333333">更新成功，请重新登录</p>
            <p style="font-size: 16px;color: #9FA5AE;margin: 10px 0">{{redirectCount}}s后为您跳转到登录页</p>
            <div class="flex-left">
                <el-button
                    size="small"
                    style="color:#194ABE;border:1px solid #194ABE;width:189px;height:50px;font-size:18px;margin-top:50px;background:#fff;margin:0 auto"
                    class="block-submit"
                    @click="toLogin"
                >立即跳转</el-button>
            </div>
            <div>
            </div>
        </div>
	</div>
</template>

<script>
import {
    AddPrize, ChangePhone, ForgetPassword, SendForgetSms, //新增奖项
} from "../utils/api.js"
import {IsCode, IsCode2, IsPaw, IsPawCompare, IsTel, IsTel2} from "../utils/validate";
	export default {
		name: "account",
		components: {
		},
		data() {
			return {
                issuccess:false,
                activeName: 'first',
				token: '',
                paw: "",
                wPaw: "", //密码提示
                code: "",
                wCode: "", //验证码提示
                newPaw: "",
                wNewPaw: "", //确认密码

                tel: "",
                wTel: "", //手机号码
                // 验证码
                show: true,
                count: '',
                timer: null,
                timer2:null,
                newPhoneData:{
                    show: true,
                    tel: "",
                    code: "",
                    wCode: "", //验证码提示
                    count: '',
                    newtel: "",
                    wPaw: "", //密码提示
                    timer: null,
                },
                redirectCount:5,
			}
		},
		async mounted() {
            let user = JSON.parse(localStorage.getItem("USERDATE"));
            this.tel = user.phone;
            this.newPhoneData.tel = user.phone;
			this.token = 'Bearer ' + localStorage.getItem("TOKEN");

		},
		methods: {
            handleClick(tab, event) {
                console.log(tab, event);
			},
            getCode() {
                const TIME_COUNT = 60;
                const data = {
                    phone: this.tel
                }
                if (IsTel(this, this.tel, "手机号码")) {
                    SendForgetSms(data).then(res => {
                        console.log(res)
                        if (!this.timer) {
                            this.count = TIME_COUNT;
                            this.show = false;
                            this.timer = setInterval(() => {
                                if (this.count > 0 && this.count <= TIME_COUNT) {
                                    this.count--;
                                } else {
                                    this.show = true;
                                    clearInterval(this.timer);
                                    this.timer = null;
                                }
                            }, 1000)
                        }
                    }).catch(err => {
                        this.$message.error(err);
                    })
                }


            },
            getCode2() {
                const TIME_COUNT = 60;
                const data = {
                    phone: this.newPhoneData.tel
                }
                if (IsTel(this, this.newPhoneData.tel, "手机号码")) {
                    SendForgetSms(data).then(res => {
                        console.log(res)
                        if (!this.newPhoneData.timer) {
                            this.newPhoneData.count = TIME_COUNT;
                            this.newPhoneData.show = false;
                            this.newPhoneData.timer = setInterval(() => {
                                if (this.newPhoneData.count > 0 && this.newPhoneData.count <= TIME_COUNT) {
                                    this.newPhoneData.count--;
                                } else {
                                    this.newPhoneData.show = true;
                                    clearInterval(this.newPhoneData.timer);
                                    this.newPhoneData.timer = null;
                                }
                            }, 1000)
                        }
                    }).catch(err => {
                        this.$message.error(err);
                    })
                }
            },
            login() {
                if (
                    IsCode(this, this.code, "验证码")&&
                    IsTel(this, this.tel, "手机号码") &&
                    IsPaw(this, this.paw, "登录密码") &&
                    IsPawCompare(this, this.newPaw, "确认密码", this.paw)
                ) {
                    console.log("校验通过");
                    const data = {
                        "password": this.paw,
                        "phone": this.tel,
                        "code": this.code
                    }
                    ForgetPassword(data).then(res => {
                        console.log(res)
                        this.$message({
                            message: '设置成功',
                            type: 'success'
                        });
                        localStorage.removeItem('TOKEN');
                        this.saveSuccess();
                    }).catch(err => {
                        this.$message.error(err);
                    })
                }
            },
            changePhone(){
                if (
                    IsCode2(this, this.newPhoneData.code, "验证码")&&
                    IsTel2(this, this.newPhoneData.tel, "手机号码") &&
                    IsTel2(this, this.newPhoneData.newtel, "新手机号码")
                ) {
                    console.log("校验通过");
                    const data = {
                        "phone": this.newPhoneData.tel,
                        "code": this.newPhoneData.code,
                        "newPhone":this.newPhoneData.newtel
                    }
                    ChangePhone(data).then(res => {
                        console.log(res)
                        this.$message({
                            message: '设置成功',
                            type: 'success'
                        });
                        localStorage.removeItem('TOKEN');
                        this.saveSuccess();
                    }).catch(err => {
                        this.$message.error(err);
                    })
                }
            },
            saveSuccess(){
                this.issuccess = true;
                this.timer2 = setInterval(() => {
                    if (this.redirectCount > 0 && this.redirectCount <= 5) {
                        this.redirectCount--;
                    } else {
                        clearInterval(this.timer2);
                        this.timer2 = null;
                        this.toLogin();
                    }
                }, 1000)
            },
            toLogin(){
                this.$router.push('/');
                localStorage.removeItem('TOKEN')
            }
		}
	}
</script>

<style lang="less" scoped>
	.infor {
		width: 858px;
		height: 800px;
		padding: 0px 30px 40px 30px;
		background: #fff;
		border-radius: 6px;
		margin-left: 14px;
		margin-bottom: 34px;
		position: relative;

		&-t {
			// padding: 14px;
			padding-top: 14px;
			border-bottom: 1px solid #D4DBDD;

			&-l {
				font-size: 28px;
				color: #181e23;
				display: inline-block;
				padding-bottom: 14px;
				font-weight: bold;
				// border-bottom: 2px solid #194abe;
			}

			&-r {
				width: 140px;
				height: 31px;
				background: #E51725;
				opacity: 1;
				overflow: hidden;
				display: table-cell;
				line-height: 31px;
				border-radius: 6px;
				cursor: pointer;

				img {
					vertical-align: middle;
					margin-right: 6px;
				}

				span {
					color: #FFFFFF;
					font-size: 14px;
				}
			}
		}

		&-c {
			text-align: justify;
			font-size: 16px;
			font-family: Microsoft YaHei;
			font-weight: 400;
			line-height: 32px;
			color: #565656;
			padding: 10px 0px;
		}

		&-img {
			text-align: center;
			padding: 24px 0px 40px 0px;
		}


	}

    .login {
        text-align: left;
        .login-form {
            width: 658px;
            //  height: 473px;
            background: #fff;
            margin: 0 auto;
            padding: 20px 20px 40px 22px;

            .login-form-lable {
                display: inline-block;
                width: 70px;
                color: #757575;
                font-size: 14px;
                text-align: right;
            }

            &_title {
                color: #272f3c;
                font-size: 24px;
                font-weight: bold;
                line-height: 26px;
                text-align: left;
                border-bottom: 1px solid #dbdbdb;
                padding-bottom: 18px;
            }

            &_item {
                width: 280px;
                height: 42px;
                border: 1px solid #bdc3cb;
                padding: 0px 11px;
                font-size: 14px;
                margin-left: 12px;
                margin-top: 10px;
            }

            .margin-top-29 {
                margin-top: 29px;
            }

            .pos-input {
                position: relative;

                .margin-top-0 {
                    margin-top: 0px;
                }

                .code-block {
                    position: absolute;
                    top: 10px;
                    right: 136px;
                    width: 102px;
                    height: 42px;
                    text-align: center;
                    line-height: 42px;
                    color: #194abe;
                    border: 1px solid #194abe;
                    font-size: 14px;
                    cursor: pointer;
                }
            }

            .login-form_assist {
                width: 280px;
                //   height: 60px;
                //  line-height: 60px;
                margin-top: 15px;
                // margin-left: 32px;
                margin-bottom: 19px;
                vertical-align: middle;

                &_isAgree {
                    display: inline-block;

                    margin-right: 8px;
                }

                &_isAgree:checked::after {
                    background: crimson;
                }

                a {
                    float: right;
                    text-decoration: underline;
                    color: #71767c;
                    font-size: 14px;
                }
            }

            .login-but {
                width: 302px;
                height: 48px;
                background: #194abe;
                opacity: 1;
                border-radius: 6px;
                // margin-left: 32px;
                color: #fff;
                font-size: 16px;
                font-weight: bold;
                border: none;
                cursor: pointer;

                margin-left: 80px;
                margin-top: 31px;
            }

            .login-clear {
                width: 302px;
                height: 48px;
                background: #fff;
                opacity: 1;
                border-radius: 6px;
                // margin-left: 32px;
                color: #7c828a;
                font-size: 16px;
                font-weight: bold;
                border: none;
                cursor: pointer;
                border: 1px solid #7c828a;
                margin-left: 80px;
                margin-top: 14px;
            }

            .login-register {
                width: 280px;
                height: 48px;
                background: #ffffff;
                opacity: 1;
                border-radius: 6px;
                // margin-left: 32px;
                color: #194abe;
                font-size: 16px;
                font-weight: bold;
                margin-top: 24px;
                text-align: center;
                line-height: 48px;
                border: 1px solid #194abe;
                cursor: pointer;
                border-radius: 6px;
            }

            .font-wraing {
                color: #ff7476;
                font-size: 14px;
                margin-left: 84px;
                margin-top: 6px;
                text-align: left;
            }

            .wraing-icon {
                display: inline-block;
                margin-right: 10px;
            }
        }
    }
    .shenhjrkr {
        margin: 71px 0 100px 0;

        img {
            width: 120px;
        }
    }
</style>
